<div class="page-header-bg text-left">
  <h1>
    <span>{{ upperTitle }}</span> {{ title }}
  </h1>

  <a
    *ngIf="showButton"
    routerLink="{{ buttonRedirectLink }}"
    class="btn btn-primary btn-sm submit"
    >{{ buttonText }}</a
  >
</div>
